import { render, staticRenderFns } from "./movie-scroll.vue?vue&type=template&id=2656770a&scoped=true&"
import script from "./movie-scroll.vue?vue&type=script&lang=js&"
export * from "./movie-scroll.vue?vue&type=script&lang=js&"
import style0 from "./movie-scroll.vue?vue&type=style&index=0&id=2656770a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2656770a",
  null
  
)

export default component.exports